import React, { useCallback, useState, useEffect } from 'react';
import { Table, Container } from 'reactstrap';
import { Timer } from 'react-countdown-clock-timer';
import { Link } from 'react-router-dom';
import Modal from '../../utils/modal';

import { Header, Footer, Main, TableMain } from './styles';

import api from '../../services/api';

import logoImg from '../../assets/logo.svg';
import bountyLogo from '../../assets/logoBounty.png';

interface DataOfBounties {
  id: number;
  bountyId: string;
  status: string;
  numberOfRoll: string;
  message: string;
  usernames: string;
  startRegistration: string;
  startBounty: string;
  ended: string;
  timeInSecondToStart: number;
}

const BountyPage: React.FC = () => {
  const [dataOfBounties, setdataOfBounties] = useState<DataOfBounties[]>([]);

  const updateTable = useCallback(async () => {
    const response = await api.get(`/bountyRoll/allBounties`);
    const ArrayOfBounty = response.data;
    setdataOfBounties(ArrayOfBounty);
  }, []);

  useEffect(() => {
    updateTable();
  }, [updateTable]);

  const bountyList = dataOfBounties;
  return (
    <>
      <Header>
        <Container className="container">
          <img src={logoImg} alt="Bitsler" />
          <div>
            <Modal buttonLabel="Rules" className="rules" modalTitle="Rules" />
          </div>
        </Container>
      </Header>
      <Main>
        <Container className="container">
          <div id="spaceOfKill">
            <img src={bountyLogo} alt="BountyLogo" />
          </div>
        </Container>
      </Main>
      <TableMain>
        <div className="containerHeader">
          <Table dark id="HighWidth">
            <thead>
              <tr>
                <th>Bounty Roll</th>
                <th>Date</th>
                <th>Participants</th>
                <th>Time registration</th>
              </tr>
            </thead>
            <tbody>
              {bountyList.map((bounty) => (
                <tr key={bounty.id}>
                  <td>
                    {bounty.message === 'Bounty Roll' && (
                      <>
                        <Link
                          to={`/firstbounty/${bounty.bountyId}`}
                          className="bold"
                        >
                          {bounty.bountyId}
                        </Link>
                      </>
                    )}
                    {bounty.message === 'newBounty' && (
                      <>
                        <Link
                          to={`/newBounty/${bounty.bountyId}`}
                          className="bold"
                        >
                          {bounty.bountyId}
                        </Link>
                      </>
                    )}
                  </td>
                  <td className="green">
                    {new Date(Number(bounty.startBounty)).toUTCString()}
                  </td>
                  <td>
                    {bounty.usernames && (
                      <>{JSON.parse(bounty.usernames).length}</>
                    )}
                    {!bounty.usernames && <>0</>}
                  </td>
                  <td className="green">
                    {bounty.timeInSecondToStart > 0 && (
                      <>
                        <Timer
                          durationInSeconds={bounty.timeInSecondToStart}
                          formatted
                        />
                      </>
                    )}
                    {bounty.timeInSecondToStart <= 0 && <>Done</>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Table dark id="LowWidth">
            <thead>
              <tr>
                <th>Bounty Roll</th>
                <th>Participants</th>
                <th>Time registration</th>
              </tr>
            </thead>
            <tbody>
              {bountyList.map((bounty) => (
                <tr key={bounty.id}>
                  <td>
                    {bounty.message === 'Bounty Roll' && (
                      <>
                        <Link
                          to={`/firstbounty/${bounty.bountyId}`}
                          className="bold"
                        >
                          {bounty.bountyId}
                        </Link>
                      </>
                    )}
                    {bounty.message === 'newBounty' && (
                      <>
                        <Link
                          to={`/newBounty/${bounty.bountyId}`}
                          className="bold"
                        >
                          {bounty.bountyId}
                        </Link>
                      </>
                    )}
                  </td>
                  <td>
                    {bounty.usernames && (
                      <>{JSON.parse(bounty.usernames).length}</>
                    )}
                    {!bounty.usernames && <>0</>}
                  </td>
                  <td className="green">
                    {bounty.timeInSecondToStart > 0 && (
                      <>
                        <Timer
                          durationInSeconds={bounty.timeInSecondToStart}
                          formatted
                        />
                      </>
                    )}
                    {bounty.timeInSecondToStart <= 0 && <>Done</>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </TableMain>
      <Footer />
    </>
  );
};

export default BountyPage;
